import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import ItemCompany from "./ItemCompany";
import { BtnSearch } from "../tools/BtnSearch";
import { observer } from "mobx-react-lite";
import User from "../../api/User";
import Media from "../../api/Media";
import { BtnFuncV4 } from "../UI/BtnFuncV4";
import Msg from "../../api/Msg";
import { ContainerSubTitleGrey } from "../ContainerSubTitleGrey";
import RolesState from "../../api/RolesState";
import FilterRegion from "./FilterRegion";
import {
  CcV4SoftList,
  CcV4SoftListBody,
  CcV4SoftListHeader,
  CcV4SoftListRow,
  CcV4Toggle,
} from "../cc-v4";
import stateRegion from "../../state/state.region";
import {
  companyMatchesVisibleRegion,
  isCompanyArchived,
} from "../../utils/companyListUtils";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { SubscriptionFilterChips } from "../UI/SubscriptionFilterChips";

const GRID_CLASS = "cc-v4-soft-grid company-list-grid";

const ListCompany = observer(
  ({
    companys,
    onClickAddNew,
    value,
    setSearch,
    linkPrefix = "/company",
    emptyTextNoData = "В базе данных не добавлено ни одной компании",
    emptyTextSearch = "Не найдено компаний, удовлетворяющих запросу. Если компания была добавлена вами только что, подождите, пожалуйста, 1 минуту и проверьте повторно.",
    searchPlaceholder =
      "Поиск по ИНН, названию и ФИО ответственного и менеджера сопровождения…",
    showArchiveToggle = true,
    showArchive = false,
    onShowArchiveChange,
    showMineOnly = false,
    onShowMineOnlyChange,
    subscriptionFilter = "all",
    onSubscriptionFilterChange,
  }) => {
    const canAdd =
      User.user.permission.includes("post_company") || User.user.is_superuser;

    const companysVisibleByRegion = useMemo(
      () =>
        companys.filter((company) =>
          companyMatchesVisibleRegion(
            company,
            stateRegion.visibleRegion,
          ),
        ),
      [companys, stateRegion.visibleRegion],
    );

    return (
      <section className="card dash-card company-list-panel" aria-label="Список">
        <div className="reports-toolbar company-list-toolbar container-list">
          <FilterRegion />
          <CcV4Toggle
            active={showMineOnly}
            label="Мои"
            onClick={() => onShowMineOnlyChange?.(!showMineOnly)}
          />
          <BtnSearch
            placeholder={searchPlaceholder}
            value={value}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className="company-list-toolbar-actions">
            {showArchiveToggle ? (
              <CcV4Toggle
                active={showArchive}
                label="В архиве"
                onClick={() => onShowArchiveChange?.(!showArchive)}
              />
            ) : null}

            {canAdd ? (
              !Media.mobile ? (
                <BtnPrimaryv4 onClick={onClickAddNew} text="Добавить" />
              ) : (
                <BtnFuncV4 onClick={onClickAddNew} />
              )
            ) : null}
          </div>
        </div>

        {onSubscriptionFilterChange ? (
          <div className="company-list-subscription-filter">
            <SubscriptionFilterChips
              value={subscriptionFilter}
              onChange={onSubscriptionFilterChange}
            />
          </div>
        ) : null}

        <CcV4SoftList>
          <CcV4SoftListHeader
            gridClass={GRID_CLASS}
            columns={[
              { key: "name", label: "Название" },
              { key: "inn", label: "ИНН" },
              { key: "address", label: "Адрес" },
              { key: "manager", label: "Менеджер" },
              { key: "support", label: "Менеджер сопровождения" },
            ]}
          />
          <CcV4SoftListBody className="company-list-body">
            {companys.length > 0 ? (
              companysVisibleByRegion.map((company) => {
                const archived = isCompanyArchived(company);
                return (
                  <CcV4SoftListRow
                    key={company.inn}
                    as={Link}
                    gridClass={GRID_CLASS}
                    className={`company-list-row${
                      archived ? " company-list-row--archived" : ""
                    }`}
                    onClick={() => sessionStorage.removeItem("soft_version")}
                    to={
                      RolesState.company_id
                        ? `${linkPrefix}/${company.inn}`
                        : Msg.writeMessages(
                            "У вас нет прав, для просмотра карточки компании",
                          )
                    }
                  >
                    <ItemCompany company={company} />
                  </CcV4SoftListRow>
                );
              })
            ) : value.length === 0 ? (
              <ContainerSubTitleGrey text={emptyTextNoData} />
            ) : (
              <ContainerSubTitleGrey text={emptyTextSearch} />
            )}
          </CcV4SoftListBody>
        </CcV4SoftList>
      </section>
    );
  },
);

export default ListCompany;
